import type { ClientMenuItem } from '@dealerportal/common';
import classNames from 'classnames';
import { NavMobileMenuItemLink } from './NavMobileMenuItemLink';

type MobileMenuProps = {
  filteredMenu: ClientMenuItem | null;
  menuItems: ClientMenuItem[];
  menuNameIncludeLowercase: (
    menu: ClientMenuItem,
    lowercaseMenuName: string
  ) => boolean;
  setFilteredMenu: (menu: ClientMenuItem | null) => void;
  ArrowIcon: React.FC<React.SVGProps<SVGSVGElement>>;
};

const MobileMenu: React.FC<MobileMenuProps> = ({
  filteredMenu,
  menuItems,
  menuNameIncludeLowercase,
  setFilteredMenu,
  ArrowIcon,
}) => {
  if (filteredMenu) {
    return (
      <ul className="!ui-list-none ui-block !ui-m-0">
        {filteredMenu.children?.map((subMenuItem, index) => (
          <NavMobileMenuItemLink
            key={`${subMenuItem.alias}-${index}`}
            depthLevel={0}
            menu={subMenuItem}
            extraItemClassName="!ui-text-[var(--cta-color,#030712)] hover:!ui-text-[var(--hover-color,#111827)] !ui-font-bold"
          />
        ))}
      </ul>
    );
  }

  return (
    <ul
      className={classNames(
        'ui-top-0 ui-left-0 ui-h-full ui-min-h-screen ui-w-full ui-z-[9999] !ui-m-0 !ui-pb-8 ui-overflow-y_auto ui-overscroll_contain ui-bg-white !ui-list-none ui-transition-transform'
      )}
    >
      {menuItems.map((menu) => {
        if (menuNameIncludeLowercase(menu, 'products')) {
          return (
            <li key={menu.name} className="ui-m-0">
              <div
                aria-hidden="true"
                className="ui-flex ui-items-center ui-justify-between ui-p-4 ui-cursor-pointer"
                onClick={() => setFilteredMenu(menu)}
              >
                {menu.name}
                <ArrowIcon className="ui-w-2 ui-rotate-90" />
              </div>
            </li>
          );
        }
        return null;
      })}
    </ul>
  );
};

export default MobileMenu;
